module.exports = __webpack_public_path__ + "static/media/Rimbayu-Starling Type D - 06-min.19c78f7b.jpg";